export const MAX_EMAIL_LENGTH = 254

const MAX_EMAIL_LOCAL_LENGTH = 64
const MAX_EMAIL_DOMAIN_LENGTH = 255
const EMAIL_PART_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~.\\-]+$/i

export const isValidEmailAddress = value => {
  if (typeof value !== 'string' || !value || value !== value.trim()) return false
  if (value.length > MAX_EMAIL_LENGTH || /\s/u.test(value)) return false
  if (/[\p{Cc}\p{Cf}]/u.test(value)) return false

  const [local, domain, ...rest] = value.split('@')
  if (
    !local ||
    !domain ||
    rest.length ||
    local.length > MAX_EMAIL_LOCAL_LENGTH ||
    domain.length > MAX_EMAIL_DOMAIN_LENGTH ||
    !domain.includes('.')
  ) {
    return false
  }

  if (!EMAIL_PART_PATTERN.test(local) || !EMAIL_PART_PATTERN.test(domain)) return false
  if (local.startsWith('.') || local.endsWith('.')) return false
  if (domain.startsWith('.') || domain.endsWith('.')) return false
  if (value.includes('..')) return false

  return true
}
